<template>
    <div class="ai_percent_box">
        <div class="ai_percent_list" v-for="(item, index) in percentDesc" :key="index">

            <div class="ai_percent_list_num">
                {{ item.num }}
            </div>
            <div class="ai_percent_list_icon">
                <span></span>
            </div>
            <div class="ai_percent_list_desc">
                {{ item.desc }}
            </div>
        </div>
    </div>
</template>

<script>
import { percentDesc } from './data';

export default {
    data() {
        return {
            percentDesc
        }
    }
}
</script>

<style lang='scss'>
.ai_percent_box {
    display: flex;
    justify-content: space-between;
    gap: 40px;

    .ai_percent_list {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 10px;
        margin-bottom: 20px;
        text-align: center;

        .ai_percent_list_icon {
            span {
                display: inline-block;
                border: 3px solid #189EAE;
                width: 17px;
            }
        }

        .ai_percent_list_num {
            font-size: 50px;
            color: #333;
            font-weight: bold;
        }

        .ai_percent_list_desc {
            font-family: none;
            color: #333;
            line-height: 1.5;
        }
    }
}

@media screen and (max-width: 576px) {
    .ai_percent_box {
        flex-direction: column;
        gap: 20px;

        .ai_percent_list {
            flex: initial;

            .ai_percent_list_desc {
                max-width: 300px;
            }
        }
    }
}
</style>